import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import appuserapi from '@/api/appuserapi';


export default /*@__PURE__*/_defineComponent({
  __name: 'docLuBillCustomActAdd',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const inputRef = ref(null);
const emits = __emit;
const currDescription = ref("");

async function addCustomLuAct() {
  const description = currDescription.value.trim();
  await appuserapi.addCustomLuAct(description);
  emits('close');
}

onMounted(() => {
  inputRef.value.innerRef.focus();
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_button_group = _resolveComponent("button-group")!

  return (_openBlock(), _createElementBlock("div", {
    style: {"margin":"1rem","padding":"1rem","width":"24rem"},
    class: "bg-modal",
    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_component_text_item, {
      txt: _unref(t)('patient.document.luBillAddon.customAct.addCustomAct'),
      class: "mtop-02 linebreak cursor-sel",
      styles: "font-l"
    }, null, 8, ["txt"]),
    _createVNode(_component_text_item, {
      txt: _unref(t)('patient.document.luBillAddon.customAct.description'),
      class: "mtop-10",
      styles: "font-mBold"
    }, null, 8, ["txt"]),
    _createVNode(_component_inputBox, { class: "mtop-03" }, {
      default: _withCtx(() => [
        _createVNode(_component_inputLineNew2, {
          ref_key: "inputRef",
          ref: inputRef,
          modelValue: currDescription.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currDescription).value = $event)),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (addCustomLuAct()), ["enter"]))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_button_group, {
      class: "mleft-08 mtop-10 psides-10",
      styles: "border-h pad-s",
      style: {"margin-left":"auto"},
      onClick: _cache[2] || (_cache[2] = ($event: any) => (addCustomLuAct()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_text_item, {
          txt: _unref(t)('action.add'),
          styles: "font-mBold"
        }, null, 8, ["txt"])
      ]),
      _: 1
    })
  ]))
}
}

})